const state = () => ({
  isValid: false,
  sex: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  sex(state) {
    return state.sex;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateSex(state, payload) {
    state.sex = payload;
  }
};

const actions = {
  updateSex({ commit }, payload) {
    commit('updateSex', payload);
  }
};

export const sex = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
